// extracted by mini-css-extract-plugin
export default {"ExternalLink":"external-link_ExternalLink__120kn","ExternalLinkInText":"external-link_ExternalLinkInText__BWUZ7","ExternalLinkButton":"external-link_ExternalLinkButton__3qicR"};